import React from 'react';
import { Icon } from 'src/components/Icons';
import GenericNotification, {
  IGenericNotification,
} from '../GenericNotification';
import { NotificationText } from '../Notifications.styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

type TErrorNotification = Pick<
  IGenericNotification,
  Exclude<keyof IGenericNotification, 'type'>
>;

const WarningNotification = ({
  text,
  ...notificationProps
}: TErrorNotification) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <GenericNotification
      type={'Warning'}
      Icon={isFromMvpApp ? null : <Icon type={'warning'} />}
      Text={<NotificationText type="warning">{text}</NotificationText>}
      {...notificationProps}
    />
  );
};

export default WarningNotification;
